import { signalStore, withMethods } from '@ngrx/signals';
import { Product } from '../shared/models/product.model';
import { ProductsService } from '../core/services/product.service';
import { withEntitiesManagement } from './features/entities-management.feature';

export const ProductsStore = signalStore(
  { providedIn: 'root' },
  withEntitiesManagement<Product>(ProductsService, 'products', 'products'),
  withMethods((store) => ({
    initialize() {
      store.loadTotalCountFromDB();
    },
  }))
);
